import { DeveloperSearchRoute } from '@search/nb-routes/src/DeveloperSearchRoute';

import initBrowserApp from '../../../../client/common/libs/init-browser-app';
import NotFoundPage from '../../../../client/desktop/components/NotFoundPage';

import instanceConfig from '../../config';

import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

import { linkBuilder } from '../../routes/routes';
import DeveloperSearchPageSeo from '../../../../client/common/components/DeveloperPageSeo';
import { DeveloperSearchPage } from '../../../../client/desktop/components/DeveloperSearchPage';

import '../../components/common/styles.css';
import '../../components/desktop/styles.css';

initBrowserApp({
    routes: [
        {
            type: 'DeveloperSearchRoute',
            route: DeveloperSearchRoute,
            Component: DeveloperSearchPage,
            SeoComponent: DeveloperSearchPageSeo
        }
    ],
    linkBuilder,
    instanceConfig,
    components: {
        Header,
        Footer,
        NotFoundPage
    }
});

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,@typescript-eslint/strict-boolean-expressions,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
// @ts-ignore
if (typeof module.hot === 'object') {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,@typescript-eslint/strict-boolean-expressions,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    module.hot.accept();
}
